import gql from 'graphql-tag';

const UPDATE_EXTERNAL_ISSUE = gql`
    mutation updateExternalIssue($input: ExternalIssueInput) {
        updateExternalIssue (input: $input) {
            internalCode
        }
    }
`;

export default UPDATE_EXTERNAL_ISSUE;
